import { useEffect } from "react";

const LiveChat = () => {
  useEffect(() => {
    var Tawk_API = Tawk_API || {};
    var Tawk_LoadStart = new Date();
    const script = document.createElement("script");

    script.async = true;
    script.src = 'https://embed.tawk.to/67f3c5fdd7c240190f022389/1io83qqa3';
    script.charset = "UTF-8";
    script.setAttribute('crossorigin', '*');
    document.getElementsByTagName("head")[0].appendChild(script);

    return () => {
      const scripts = document.getElementsByTagName('script');
      for (let i = 0; i < scripts.length; i++) {
        if (scripts[i].src.includes('tawk.to')) {
          scripts[i].remove();
        }
      }
    };
  }, []);

  return null; // No UI element needed
};

export default LiveChat;
